import { Link } from 'react-router-dom'
import './Blog.css'

const Blog = () => {
    return (
        <article id="Blog" className="blog">
            <div className="nub inverted"/>
            <h2>Blog</h2>

            <div className="blogs">
                <div className="vertical-nub" />
                <ul className="blog-links">
                    <Link to="blog/userinterfaces">
                        <li>
                                <p className="title">User Interfaces</p>
                                <p className="date">Aug. 19, 2025</p>
                        </li>
                    </Link>
                </ul>
                <div className="vertical-nub inverted" />
            </div>


            <div className="nub bottom"/>

        </article>
    );
}

export default Blog;